export const SET_GAME_INFORMATION = "SET_GAME_INFORMATION";
export const SET_PLAYER_COUNT = "SET_PLAYER_COUNT";
export const SET_PLAYER_SORT_TYPE = "SET_PLAYER_SORT_TYPE";
export const SET_PLAYER_POSITION_FILTER = "SET_PLAYER_POSITION_FILTER";
export const SET_MAINPAGE_VIEW = "SET_MAINPAGE_VIEW";
export const SET_SELECTED_PLAYER_STATS = "SET_SELECTED_PLAYER_STATS";
export const SET_DISPLAY_PLAYERS = "SET_DISPLAY_PLAYERS";
export const SET_GOBACK_BOOLEAN = "SET_GOBACK_BOOLEAN";
export const SET_TEAMNAME_SELECTED_PLAYER = "SET_TEAMNAME_SELECTED_PLAYER";
export const SET_TIME_HOURS = "SET_TIME_HOURS";
export const SET_TIME_MINUTES = "SET_TIME_MINUTES";
export const SET_TIME_SECONDS = "SET_TIME_SECONDS";
export const SET_MATCH_DATETIME = "SET_MATCH_DATETIME";
export const SET_PL_RES = "SET_PL_RES";
export const SET_PLAYER_SEARCHED_NAME = "SET_PLAYER_SEARCHED_NAME";
export const SET_GAME_TEAMS = "SET_GAME_TEAMS";
export const SET_TEAM_FILTER = "SET_TEAM_FILTER";
export const SET_API_FLAG = "SET_API_FLAG";
export const SET_LEAGUE = "SET_LEAGUE";
export const SET_SELECTED_TIMEFRAME = "SET_SELECTED_TIMEFRAME";
export const SET_SLATE_ID = "SET_SLATE_ID";
export const SET_COMPLETE_GAME_INFORMATION = "SET_COMPLETE_GAME_INFORMATION";
export const SET_AVAILABLE_TIMEFRAMES = "SET_AVAILABLE_TIMEFRAMES";
export const SET_AUTO_LINEUP_GEN_BAR_OPEN_FLAG = "SET_AUTOGEN_BAR_OPEN_FLAG";
export const SET_IN_MEMORY_TIMEFRAMES = "SET_IN_MEMORY_TIMEFRAMES";
export const SET_HORIZONTAL_SCROLL_POSITION = "SET_HORIZONTAL_SCROLL_POSITION";
export const SET_PL_STATUS = "SET_PL_STATUS";
export const SET_PLAYER_LOCKED_COUNT = "SET_PLAYER_LOCKED_COUNT";
export const SET_PLAYER_FAVOURITE_COUNT = "SET_PLAYER_FAVOURITE_COUNT";
export const SET_PLAYER_EXCLUDED_COUNT = "SET_PLAYER_EXCLUDED_COUNT";
export const SET_PLAYER_LFD_COUNT = "SET_PLAYER_LFD_COUNT";
export const SET_IS_RESET_CLICKED = "SET_IS_RESET_CLICKED";
export const UPDATE_PLAYER_LFD_FLAG = "UPDATE_PLAYER_LFD_FLAG";
export const SIGNOUT_REQUEST = "SIGNOUT_REQUEST";
export const DATA_REQUEST = "DATA_REQUEST";
export const DATA_SUCCESS = "DATA_SUCCESS";
export const DATA_ERROR = "DATA_ERROR";
